import { render, staticRenderFns } from "./Profit_and_loss.vue?vue&type=template&id=34cc5149"
import script from "./Profit_and_loss.vue?vue&type=script&lang=js"
export * from "./Profit_and_loss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports